import React from 'react';
import PropTypes from 'prop-types';
import QuestionFooter from 'containers/QuestionnairePage/GenericQuestion/QuestionFooter';
import QuestionPrompt from '../QuestionPromptViewOnly';

const PromptQuestionViewOnly = ({
  question,
  renderPrompt,
  icon,
  attributes,
}) => (
  <div>
    <QuestionPrompt
      className="margin-btm-xxs"
      icon={icon}
      renderPrompt={renderPrompt}
      questionIndex={question.questionIndex}
      label={question.label}
    />
    <QuestionFooter
      key={`${question.refId}-${question.type}-footer`}
      type={question.type}
      label={question.label}
      goesTo={question.goesTo}
      goesToWithErrors={question.goesToWithErrors}
      comesFrom={question.comesFrom}
      isUnused={question.isUnused}
      invalidReferences={question.invalidReferences}
      invalidReferencesAnswersLogic={question.invalidReferencesAnswersLogic}
      invalidReferencesVariablesLogic={question.invalidReferencesVariablesLogic}
      media={question.media}
      shuffle={question.shuffle}
      ratingSize={question.ratingSize}
      selectedAttributes={question.selectedAttributes}
      answers={question.answers}
      attributes={attributes}
      hiddenVariables={question.hiddenVariables}
      readOnly
    />
  </div>
);

PromptQuestionViewOnly.propTypes = {
  question: PropTypes.object.isRequired,
  renderPrompt: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  attributes: PropTypes.array.isRequired,
};

export default PromptQuestionViewOnly;
